import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbkhazia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_5)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.3971 3.42862C18.2327 1.308 15.2694 0 12 0C10.9565 0 7.9034 1.308 5.73914 3.42862H20.3971Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 10.2857H23.8776C23.7044 9.07519 23.3508 7.92301 22.8445 6.85716H11.4783L12 10.2857Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.15551 17.1429H22.8445C23.3508 16.0771 23.7044 14.9248 23.8776 13.7143H0.122437C0.29564 14.9249 0.649124 16.0771 1.15551 17.1429Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.60291 20.5714C5.76726 22.692 8.73061 24 12 24C15.2694 24 18.2327 22.692 20.3971 20.5714H3.60291Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C5.95472 0 0.954374 4.47052 0.122437 10.2857H12V0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.00001 9.20001L5.47829 8.15658V6.06961L6.78263 5.02612L8.08697 6.06961V7.63481L8.60869 7.11309V8.15658L7.56521 9.20001H6.00001Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.19383 6L3.33197 6.42516H3.77897L3.41733 6.68798L3.55552 7.11309L3.19383 6.85031L2.83214 7.11309L2.97033 6.68798L2.60869 6.42516H3.05569L3.19383 6Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.23732 4.95651L4.37546 5.38167H4.8225L4.46082 5.6445L4.59896 6.06961L4.23732 5.80687L3.87568 6.06961L4.01386 5.6445L3.65218 5.38167H4.09913L4.23732 4.95651Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.2808 3.91302L5.41894 4.33818H5.8659L5.5043 4.60101L5.6424 5.02612L5.2808 4.76338L4.91912 5.02612L5.05726 4.60101L4.69566 4.33818H5.14262L5.2808 3.91302Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3714 6L10.2332 6.42516H9.78627L10.1479 6.68798L10.0097 7.11309L10.3714 6.85031L10.7331 7.11309L10.5949 6.68798L10.9565 6.42516H10.5096L10.3714 6Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.32789 4.95651L9.18975 5.38167H8.7428L9.10439 5.6445L8.96625 6.06961L9.32789 5.80687L9.68958 6.06961L9.55139 5.6445L9.91303 5.38167H9.46608L9.32789 4.95651Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.28445 3.91302L8.14626 4.33818H7.69931L8.0609 4.60101L7.92276 5.02612L8.28445 4.76338L8.64609 5.02612L8.50795 4.60101L8.86954 4.33818H8.42259L8.28445 3.91302Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78262 3.39131L6.64443 3.81647H6.19748L6.55907 4.07925L6.42093 4.50436L6.78262 4.24162L7.14426 4.50436L7.00612 4.07925L7.36771 3.81647H6.92076L6.78262 3.39131Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_5",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAbkhazia;
